import Embed from './embed'

export default Embed
